<template>
	<div class="main-wrapper col-5 d-none p-0 d-lg-block">
		<div ref="main-wrapper" class="slider-desktop-wrapper"></div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import DesktopSlider from "@/vue/planning/desktopSlider";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "SliderDesktop",
	props: {
		prestation: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {},
	data() {
		return {
			data: {
				slider: null,
			},
			state: {},
		};
	},
	computed: {
		...mapState(["screenType"]),
	},
	methods: {
		initSlider() {
			if (this.data.slider) return;

			const slider = new DesktopSlider(
				this.prestation.picturesAccomodation,
				this.$refs["main-wrapper"]
			);
			slider.init();
			this.data.slider = slider;
		},
	},

	mounted() {
		this.$nextTick(() => {
			if (this.screenType === "desktop") {
				this.initSlider();
			}
		});
	},
	watch: {
		screenType: function (newValue, oldValue) {
			if (newValue === "desktop") {
				this.initSlider();
			} else {
				this.data.slider = null;
				this.$refs["main-wrapper"].innerHTML = "";
			}
		},
	},
};
</script>

<style>
.slider-desktop-wrapper {
	display: grid;
	grid-template-rows: 300px 70px;
}

.popup-prestation-slider-desktop,
.popup-prestation-image-list {
	height: 80px;
}

.popup-prestation-image-list .popup-prestation-image-wrapper {
	padding: 1px;
}

.popup-prestation-image-list.animate {
	transition: left 250ms ease-in-out, right 250ms ease-in-out;
}

.popup-prestation-image-wrapper.active img {
	border: 2px solid var(--primary-blue);
}

.main-popup-img {
	height: 350px;
	overflow: hidden;
	border-radius: 8px;
}

.popup-prestation-image-wrapper,
.main-popup-img img {
	object-fit: cover;
	width: 100%;
	height: 100%;
}

.slider-btn-desktop,
.main-popup-img-controls {
	top: 50%;
	transform: translateY(-50%);
}

.slider-btn-desktop.left,
.main-popup-img-controls.left {
	left: 5px;
	z-index: 1;
}

.slider-btn-desktop.right,
.main-popup-img-controls.right {
	right: 5px;
	z-index: 1;
}

.main-popup-img-controls.left {
	left: 5px;
}
.main-popup-img-controls.right {
	right: 5px;
}

.slide-left {
	left: 10px;
}
.slide-right {
	right: 10px;
}

.slider-btn-desktop {
	top: 50%;
	transform: translateY(-50%);
	z-index: 5;
}
.slider-btn-desktop.left {
	left: 10px;
}
.slider-btn-desktop.right {
	right: 10px;
}

.popup-prestation-image-list {
	transition: left 150ms ease-in-out;
}

.popup-prestation-image-wrapper img {
	object-fit: cover;
	max-width: 100%;
	max-height: 100%;
	height: 100%;
	border-radius: 7px;
}

.slider-desktop-wrapper button {
	background-color: transparent;
	border: none;
}

.slider-desktop-wrapper button:focus,
.slider-desktop-wrapper button:active {
	outline: none;
}
</style>
